<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">

    <div class="col-md-8 no-padding">

        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Find Connection</span>
            </h6>
        </div>
        <div class="col-xl-12 block-style" style="margin-bottom:15px !important;padding: 20px !important; border-top-right-radius: 0px; border-top-left-radius: 0px">
            <div class="row small-section-content">
                <div class="col-xl-12 text-center empty" style="margin-bottom: 15px;">
                    <p style="text-align: left; padding-top: 0px; font-size: 12px;"><b>TIP: </b>You can narrow down your search result by:</p>
                    <p style="text-align: left; padding-top: 0px; font-size: 12px;">1. Typing the name of the connection in a specific company Ex: [Name] in [Company Name]</p>
                    <p style="text-align: left; padding-top: 0px; font-size: 12px;">2. Typing the email address</p>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                <div class="input-group">
                    <input (keyup)="findEnter($event)" [(ngModel)]="findConnectionTxt" type="text" class="form-control" placeholder="find connection...">
                    <span class="input-group-btn">
                        <button (click)="findConnection()" class="btn-fa btn-search" type="button">
                            <span class="fa fa-search"></span>
                        </button>
                    </span>
                </div>
            </div>

            <div class=" row" style="margin-bottom:20px">
                <div class="col-xl-12"><h4>Search Result ({{searchResult.length}})</h4></div>
                <div *ngIf="searchLoading" class="col-xl-12 no-padding">
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div *ngFor="let item of searchResult | slice:0:pageSizeSearch ; let i = index" class="col-xl-12 ">
                    <div class="row userlist" style="padding:10px">
                        <div class="col-xl-10">
                            {{item.firstName}} {{item.lastName}}<br />
                            <small class="feed-time-date">
                                <span *ngIf="item.title != ''  ">{{item.title}}</span>
                                <span *ngIf="item.accountName  != '' && item.title  != ''  "> , </span>
                                <span *ngIf="item.accountName  != ''  ">{{item.accountName}}</span>
                            </small>
                        </div>
                        <div class="col-xl-2">
                            <img *ngIf="item.source == 'connection'" class="" tooltip="Already in your connection" src="assets/images/alreadyConnection.png" />
                            <img *ngIf="item.source == 'portal'" (click)="sendConnectionRequestInvitation(item, i)" class="" style="cursor: pointer" tooltip="Send Request Invitation" src="assets/images/addConnection.png" />
                            <img *ngIf="item.source == 'salesforce'" (click)="sendInvitation(item, i)" class="" style="cursor: pointer" tooltip="Invite to Portal" src="assets/images/inviteConnection.png" />
                        </div>
                    </div>
                </div>
                <div *ngIf="searchResult.length > pageSizeSearch" class="col-xl-12 text-center" style="margin-top:20px">
                    <button style="height:40px" (click)="moreSearch()" class="btn btn mygistec-btn-outline">explore more connections</button>
                </div>
            </div>


        </div>

        <div *ngIf="connectionYouMayKnow.length > 0" class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Connections you may know</span>
            </h6>
        </div>
        <div *ngIf="connectionYouMayKnow.length > 0" class="col-xl-12 block-style" style="margin-bottom:15px !important;padding: 20px !important; border-top-right-radius: 0px; border-top-left-radius: 0px">
            <!--connection you may know-->
            <div *ngIf="connectionYouMayKnow.length > 0" class=" row">
                <div class="col-xl-12"><h4>Results ({{connectionYouMayKnow.length}})</h4></div>
                <div *ngFor="let item of connectionYouMayKnow | slice:0:pageSizeYouMayKnow; let i = index" class="col-xl-12 ">
                    <div class="row userlist" style="padding:10px">
                        <div class="col-xl-2" style="padding:0px; cursor:pointer" (click)="openUserProfile(item.id)">
                            <div class="postContactLogo default-bg" style="border-radius: 50%; background-size: cover; width: 40px; height: 40px" [ngStyle]="{'background-image': 'url(' + item.contactLogo + ')'}">
                            </div>
                        </div>
                        <div class="col-xl-8" style="cursor: pointer;" (click)="openUserProfile(item.id)">
                            {{item.firstName}} {{item.lastName}}<br />
                            <small class="feed-time-date">
                                <span *ngIf="item.title != ''  ">{{item.title}}</span>
                                <span *ngIf="item.portalAccount.name  != '' && item.title  != ''  "> , </span>
                                <span *ngIf="item.portalAccount.name  != ''  ">{{item.portalAccount.name}}</span>
                            </small>
                        </div>
                        <div class="col-xl-2">
                            <img (click)="sendConnectionRequestInvitationConnectionYouMayKnow(item, i)" class="" style="cursor: pointer" tooltip="Send Request Invitation" src="assets/images/addConnection.png" />

                        </div>
                    </div>
                </div>
                <div *ngIf="connectionYouMayKnow.length > pageSizeYouMayKnow" class="col-xl-12 text-center" style="margin-top:20px">
                    <button style="height:40px" (click)="moreYouMayKnow()" class="btn btn mygistec-btn-outline">explore more connections</button>
                </div>
            </div>

        </div>


    </div>
    <div class="col-md-4">
        <app-connection-list [showLoading]="myConnectionShowLoading" [title]="'Your connection list'" [connectionList]="myConnection"></app-connection-list>
        <app-connection-list [showLoading]="mySentConnectionShowLoading" [title]="'You sent ' + sentConnection.length + ' connection requests'" [connectionList]="sentConnection"></app-connection-list>
        <app-connection-list [showLoading]="myRequestedConnectionShowLoading" [title]="'You have ' + requestedConnection.length + ' connection requests'" [connectionList]="requestedConnection"></app-connection-list>
    </div>
</div>
